interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  color?: 'cyan' | 'blue' | 'green' | 'red';
  text?: string;
  className?: string;
}

const sizeClasses = { sm: 'w-4 h-4 border-2', md: 'w-8 h-8 border-3', lg: 'w-12 h-12 border-4' };
const colorClasses = {
  cyan: 'border-cyan-500 border-t-transparent',
  blue: 'border-blue-500 border-t-transparent',
  green: 'border-green-500 border-t-transparent',
  red: 'border-red-500 border-t-transparent',
};

function LoadingSpinner({ size = 'md', color = 'cyan', text, className = '' }: LoadingSpinnerProps) {
  const spinner = <div className={`${sizeClasses[size]} ${colorClasses[color]} rounded-full animate-spin ${className}`}></div>;

  if (text) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="flex flex-col items-center gap-3">
          {spinner}
          <p className="text-gray-500 text-sm">{text}</p>
        </div>
      </div>
    );
  }

  return <div className="flex items-center justify-center py-12">{spinner}</div>;
}

export default LoadingSpinner;
export { LoadingSpinner };
